export const SCREAMING_SNAKE_CASE_RE = /^[A-Z][A-Z0-9_]*$/;
